/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface AdresseDoublonSearchDto
 */
export interface AdresseDoublonSearchDto {
    /**
     * 
     * @type {number}
     * @memberof AdresseDoublonSearchDto
     */
    idpersonne?: number;
    /**
     * 
     * @type {number}
     * @memberof AdresseDoublonSearchDto
     */
    idtypeAdresse?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdresseDoublonSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof AdresseDoublonSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof AdresseDoublonSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdresseDoublonSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof AdresseDoublonSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof AdresseDoublonSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the AdresseDoublonSearchDto interface.
 */
export function instanceOfAdresseDoublonSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AdresseDoublonSearchDtoFromJSON(json: any): AdresseDoublonSearchDto {
    return AdresseDoublonSearchDtoFromJSONTyped(json, false);
}

export function AdresseDoublonSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdresseDoublonSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idpersonne': !exists(json, 'idpersonne') ? undefined : json['idpersonne'],
        'idtypeAdresse': !exists(json, 'idtypeAdresse') ? undefined : json['idtypeAdresse'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function AdresseDoublonSearchDtoToJSON(value?: AdresseDoublonSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idpersonne': value.idpersonne,
        'idtypeAdresse': value.idtypeAdresse,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

